// extracted by mini-css-extract-plugin
export default {"SkipLink":"SkipToContent-module__SkipLink--tsv14"};